<!-- In your GptPopupComponent template -->
<div class="modal-header">
  <h4 class="modal-title">AI Suggestion</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()">
  </button>
</div>
<div class="modal-body">
  <!-- Show loading spinner when isLoading is true -->
  <div *ngIf="isLoading ||loading" class="text-center">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Generating...</span>
    </div>
    <p class="mt-2">Generating AI suggestion...</p>
  </div>
  
  <!-- Show content when not loading -->
  <div *ngIf="!isLoading &&!loading">
    <textarea class="form-control" rows="6" [(ngModel)]="description"></textarea>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)=" genratefromAI()">Regenerate</button>
  <button type="button" class="btn btn-primary" [disabled]="isLoading" (click)="onInsertClick()">Insert</button>
</div>